import { ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";
import { track } from "@/lib/track";

// Anchor that opens an Exercise.com / external link in a new tab.
// Pass `trackType` (and optional `trackLabel`) to log a conversion event.
export const ExternalCta = ({ href, children, className, variant = "primary", showIcon = true, testid = "external-exercisecom-link", trackType, trackLabel, onClick, ...rest }) => {
  const base = "inline-flex items-center justify-center gap-2 rounded-md px-5 py-3 text-sm font-semibold uppercase tracking-wide transition-colors duration-200 active:scale-[0.98]";
  const variants = {
    primary: "bg-brand text-white hover:bg-[hsl(var(--brand-red-deep))]",
    secondary: "border border-border bg-transparent text-foreground hover:bg-accent",
    dark: "bg-foreground text-background hover:opacity-90",
  };
  const handleClick = (e) => {
    if (trackType) track(trackType, trackLabel || (typeof children === "string" ? children : ""), { href });
    if (onClick) onClick(e);
  };
  return (
    <a
      href={href || "#"}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={handleClick}
      className={cn(base, variants[variant], className)}
      {...rest}
    >
      {children}
      {showIcon && <ExternalLink className="h-4 w-4" />}
    </a>
  );
};
